<template>
  <Transition
    :name="transitionName"
    :css="useCss"
    :appear="appear"
    :mode="mode"
    :duration="transitionDuration"
    @before-enter="onBeforeEnter"
    @enter="onEnter"
    @after-enter="onAfterEnter"
    @before-leave="onBeforeLeave"
    @leave="onLeave"
    @after-leave="onAfterLeave"
  >
    <slot />
  </Transition>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { ANIMATION_PRESETS } from '@base/data/animations-presets';

interface Props {
  preset?: keyof typeof ANIMATION_PRESETS;
  enterAnimation?: string;
  leaveAnimation?: string;
  mode?: 'in-out' | 'out-in' | 'default';
  useCss?: boolean;
  appear?: boolean;
  customEnterClass?: string;
  customLeaveClass?: string;
}

const { preset = 'reveal', mode = 'default', useCss = true, appear = false } = defineProps<Props>();

const emit = defineEmits<{
  beforeEnter: [];
  enter: [];
  afterEnter: [];
  beforeLeave: [];
  leave: [];
  afterLeave: [];
}>();

// Имя transition для Vue
const transitionName = computed(() => preset);

const transitionDuration = computed(() => {
  const config = ANIMATION_PRESETS[preset];
  return {
    enter: config?.enter?.duration ?? 400,
    leave: config?.leave?.duration ?? 400,
  };
});

const onBeforeEnter = (el: Element) => {
  emit('beforeEnter');
};

const onEnter = async (el: Element, done: () => void) => {
  emit('enter');
};

const onAfterEnter = (el: Element) => {
  emit('afterEnter');
};

const onBeforeLeave = (el: Element) => {
  emit('beforeLeave');
};

const onLeave = async (el: Element, done: () => void) => {
  emit('leave');
};

const onAfterLeave = (el: Element) => {
  emit('afterLeave');
};
</script>

<style lang="scss">
</style>
